// Cíl přesměrování po přihlášení. Bereme jen interní cestu z ?redirect,
// aby se nedalo přes odkaz odskočit na cizí doménu, jinak padáme na homeLink.
export function loginRedirectTarget(redirect: unknown): string {
  const homeLink = useRuntimeConfig().public.homeLink as string
  const path = typeof redirect === 'string' ? redirect : ''

  if (!path.startsWith('/') || path.startsWith('//')) return homeLink

  // Na přihlašovací obrazovku se vracet nemá smysl, zacyklilo by se to
  if (path === '/' || path.startsWith('/?')) return homeLink

  return path
}
